"use strict";
// (C) 2021-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.metaInitialState = exports.EmptyDashboardDescriptor = void 0;
exports.EmptyDashboardDescriptor = {
    title: "",
    description: "",
    shareStatus: "private",
};
exports.metaInitialState = {
    descriptor: exports.EmptyDashboardDescriptor,
    persistedDashboard: undefined,
};
//# sourceMappingURL=metaState.js.map